export default function () {
  const widgetName = "videoWidget";
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append("<iframe></iframe>");
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${widgetName}`).videoWidget({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    detectIpad: IPADDETECTED,
    showOnMobile: true,
    showControls: true,
    multiVideo: false,
    autoPlayVideo: false,
    loopVideo: false,
    maxVideos: 1,

    videoWidgetLoaded: function (data) {
      const videoCount = data.Slides.length > 0;

      if (!videoCount) {
        $(`#${widgetName}`).remove();
        $(body).addClass("noVideoLoaede");
        $(".tier-4-container .inner-content").addClass("noVideoLoaede");
      }
    },
  });
}
